module.exports = __webpack_public_path__ + "img/IMG_2729_L.8545772d.webp";